export default {
	GET_ALL: (crewId) => `/economos/list/all?crewId=${crewId}`,
	CREATE: (crewId) => `/economos/list?crewId=${crewId}`,
	UPDATE: () => "/economos/list",
	DELETE: (id) => `/economos/list/${id}`,
};
